import { render, staticRenderFns } from "./ProjectDatesRibbon.vue?vue&type=template&id=c2a74762&"
import script from "./ProjectDatesRibbon.vue?vue&type=script&lang=js&"
export * from "./ProjectDatesRibbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports